import { render, staticRenderFns } from "./LeadOrderReceiptSummary.vue?vue&type=template&id=94666a0c&"
import script from "./LeadOrderReceiptSummary.vue?vue&type=script&lang=js&"
export * from "./LeadOrderReceiptSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports